import colors from "exports.module.scss";

import {
  Box,
  styledWithConfig,
  Text,
  useForegroundVariantColor,
  useShadow,
  useTheme
} from "@seneca/senekit";

import { ReactComponent as ParentImg } from "common/assets/images/sign-up/parent.svg";
import { ReactComponent as StudentImg } from "common/assets/images/sign-up/student.svg";
import { ReactComponent as TeacherImg } from "common/assets/images/sign-up/teacher.svg";

import { colorWithOpacity } from "seneca-common/utils/styles";

const { carnation, ecstasy, fuchsia } = colors;

export const accountTypeBtn = {
  student: {
    backgroundColor: colorWithOpacity(ecstasy, 0.3),
    image: <StudentImg />,
    displayName: "student"
  },
  teacher: {
    backgroundColor: colorWithOpacity(carnation, 0.3),
    image: <TeacherImg />,
    displayName: "teacher"
  },
  parent: {
    backgroundColor: colorWithOpacity(fuchsia, 0.3),
    image: <ParentImg />,
    displayName: "parent"
  }
};

const Button = styledWithConfig("button");
export type AccountType = keyof typeof accountTypeBtn;
type Props = {
  accountType: AccountType;
  selected: boolean;
  onClick?: () => void;
};

export default function AccountTypeButton({
  accountType,
  selected,
  onClick
}: Props) {
  const styles = useGetCustomStyles(selected);
  const foregroundVariant = useForegroundVariantColor("1");
  const boxShadow = useShadow("small");

  return (
    <Button
      display="flex"
      justifyContent={["flex-start", "center"]}
      flexDirection={["row", "column"]}
      alignItems="center"
      padding={"xlarge"}
      width="100%"
      borderStyle="solid"
      borderWidth="xxxsmall"
      borderRadius="small"
      backgroundColor={foregroundVariant}
      boxShadow={boxShadow}
      onClick={onClick}
      {...styles}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        width="64px"
        height="64px"
        backgroundColor={accountTypeBtn[accountType].backgroundColor}
        borderRadius="xxxlarge"
        marginBottom={["none", "xlarge"]}
        marginRight={["xlarge", "none"]}
      >
        {accountTypeBtn[accountType].image}
      </Box>
      <Text
        align="center"
        tone={selected ? "primary" : "neutral"}
        weight="bold"
      >
        I'm a {accountType}
      </Text>
    </Button>
  );
}

function useGetCustomStyles(selected: boolean) {
  const theme = useTheme();

  return {
    borderColor: selected ? theme["primary-medium-content"] : "transparent",
    color: selected
      ? theme["primary-high-content"]
      : theme["neutral-high-content"],
    cursor: selected ? undefined : "pointer",
    hoverStyles: {
      borderColor: theme["primary-medium-content"]
    }
  };
}
